import { useEffect } from 'react';
import { captureAttribution } from '../lib/attribution';

export function useAttributionCapture(): void {
  useEffect(() => {
    captureAttribution();
  }, []);
}
